import { render, staticRenderFns } from "./TrainingConfiguration.vue?vue&type=template&id=2655126e&"
import script from "./TrainingConfiguration.vue?vue&type=script&lang=js&"
export * from "./TrainingConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./TrainingConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports